import styled from 'styled-components';

export const Container = styled.div`
  position: relative;

  width: 100%;
  min-height: 100%;
  padding: 72px;
  overflow: scroll;

  background: #f1f4f5;
`;

export const Header = styled.div`
  margin-bottom: 32px;

  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const HeaderLeft = styled.div``;

export const HeaderRight = styled.div`
  gap: 24px;
  display: flex;
`;

export const CotacaoGrid = styled.div`
  margin-top: 32px;
  gap: 32px;

  display: grid;
  grid-template-columns: repeat(4, 1fr);

  @media only screen and (max-width: 1600px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media only screen and (max-width: 1000px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const PaginationContainer = styled.div`
  position: sticky;
  bottom: 0;

  width: 100%;
  padding: 16px;

  background-color: #fff;

  display: flex;
  justify-content: center;
  align-items: center;
`;
